module.exports = __webpack_public_path__ + "img/083.eaad656c.png";